/**
 * Prozo's published evidence-strength scoring, shared between the Weight
 * Dispute Evidence Studio and the Weight Freeze evidence locker.
 *
 * These weights are PRODUCT ASSERTIONS, not tunable config: a complete
 * packing video is worth more on its own (62) than all five stills combined
 * (30), because on Prozo's record video settles about 97% of requests and
 * images on their own about 52%. Changing a number here changes what the
 * business claims, so change it only when the business does.
 *
 * `disputes-v2/state/evidenceScore.js` is a DIFFERENT, coarser function over
 * a dispute row (100 / 50 / 0 with its own published ~100% / ~50% rates for
 * disputes rather than freezes). Both are correct for their own surface —
 * this file exists so the granular Freeze/Evidence-Studio scoring is not
 * owned by the Freeze module, since the same weights drive both surfaces.
 * DO NOT modify the Disputes file to "share" this one; a drift-guard test in
 * evidenceScore.test.js instead asserts the two agree on the one thing they
 * must never disagree on — that video ranks above images ranks above
 * nothing — so a future edit to either file fails loudly if it breaks that.
 */
export const EVIDENCE_LEVEL = {STRONG: 'strong', FAIR: 'fair', WEAK: 'weak'}

/** Prozo's published approval rates for a freeze request, as percentages. */
export const APPROVAL_RATE = {VIDEO: 97, IMAGES_ONLY: 52}

const MAX_SCORED_SLOTS = 5

export function evidenceScore({video = false, imageSlots = 0, category = false, remark = false} = {}) {
  const slots = Math.max(0, imageSlots || 0)
  let score = 0
  if (video) score += 62
  score += Math.min(slots, MAX_SCORED_SLOTS) * 6
  if (category) score += 5
  if (remark) score += 3
  score = Math.min(100, score)

  const win = video
    ? Math.min(97, 70 + slots * 5)
    : slots >= 3 ? 58
      : slots >= 1 ? 41
        : 6

  const level = score >= 70 ? EVIDENCE_LEVEL.STRONG
    : score >= 40 ? EVIDENCE_LEVEL.FAIR
      : EVIDENCE_LEVEL.WEAK

  return {score, win, level}
}
